import { composeClassNames } from "@faedev/editor-utils";
import { Col, Row } from "react-bootstrap";
import Heading from "src/components/Heading";
import gutter from "src/functions/gutter";
import { sAlign } from "src/styles/sAlign.module.scss";
import { sList } from "src/styles/sList.module.scss";

function UserTermsPrivacyCs3() {
  return (
    <div>
      <Heading
        type={`h3`}
        title={
          <>
            {`III.`}
            <br />
            {`Uzavření smlouvy`}
          </>
        }
        className={composeClassNames([sAlign, "center"])}
        style={gutter(`margin`, `top`, `md`)}
      />
      <Row>
        <Col sm={6} xs={12}>
          <ol className={sList}>
            <li>{`Návrh na uzavření smlouvy o poskytování přístupu do služby provede uživatel vyplněním údajů v registračním formuláři uživatelského účtu, souhlasem s těmito obchodními podmínkami a odesláním těchto údajů poskytovateli (dále jen „objednávka“). `}</li>
            <li>{`Po doručení objednávky a po úhradě příslušné služby či prvního období služby poskytovatel umožní uživateli přístup k webové stránce, tj. přístup ke zvolenému obsahu. `}</li>
          </ol>
        </Col>
        <Col sm={6} xs={12}>
          <ol start={3} className={sList}>
            <li>{`Poskytovatel je oprávněn odmítnout objednávku uživatele, a to zejména u osob, které dříve podstatným způsobem porušily smlouvy s poskytovatelem či tyto obchodní podmínky. `}</li>
            <li>{`Poskytovatel je oprávněn postoupit práva a povinnosti ze smlouvy na třetí osobu, a to i bez souhlasu uživatele.`}</li>
          </ol>
        </Col>
      </Row>
    </div>
  );
}

export default UserTermsPrivacyCs3;
